function createContainer(placementId, count, position, clickTrackUrlValue, index) {
  const container = {
    containerId: placementId,
    adSlots: count || 1,
    position: position || 'Mainline',
    width: 1000,
    adTypesFilter: 'TextAds',
    clickTrackUrl: `${clickTrackUrlValue}&block=${index}`,
    adStyle: {
      textAd: {
        titleColor: '#000000',
        urlColor: '#000000',
        boldTitle: true,
        boldUrl: false,
        verticalSpacing: 12,
        backgroundColor: '#FAFAFA',
        borderColorForAd: '#FFFFFF',
        borderRadiusForAd: 10,
        borderColorForAdContainer: '#FFFFFF',
      },
      textExtension: {
        siteLinks: {
          fontSize: 16,
        },
        action: {
          color: '#1A0DAB',
        },
      },
    },
  };
  return container;
}

function mountBingJsScript(dabuRes) {
  const {
    q,
  } = this.pageParams;
  const {
    adUnitId, clarityId, adLanguage, query,
  } = dabuRes;
  const { bingJsOptions = { slug: '', sksAsQuery: false } } = this.win.amgAds || {};
  const queryOption = query || q || bingJsOptions.slug || this.doc.title;
  const { dabuPlacementId } = this.dataset;
  const {
    rtb,
  } = this.pageParams;
  const clickTrackUrl = this.getBingJsAdsClickTrackUrl();
  const containers = [];
  if (bingJsOptions.blocks) {
    bingJsOptions.blocks.forEach((block, index) => {
      containers.push(createContainer(
        block.placementId,
        block.count,
        block.position,
        clickTrackUrl,
        index,
      ));
    });
  } else {
    dabuPlacementId.split(',').forEach((placementId, index) => {
      containers.push(createContainer(placementId, 1, 'Mainline', clickTrackUrl, index));
    });
  }
  const clarityScript = this.doc.createElement('script');
  const searchScript = this.doc.createElement('script');
  searchScript.setAttribute('type', 'text/javascript');
  searchScript.src = 'https://msadsscale.azureedge.net/bingads/searchads.js';
  clarityScript.setAttribute('type', 'text/javascript');
  clarityScript.innerHTML = `(function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y); })(window,
    document, "clarity", "script", "${clarityId}");`;

  const initAdJS = this.doc.createElement('script');
  initAdJS.setAttribute('type', 'text/javascript');
  initAdJS.setAttribute('charset', 'utf-8');

  initAdJS.innerHTML = `
  var adsParameter = {
    "adUnitId": "${adUnitId}",
    "query": "${queryOption}",
    "adLanguage": "${adLanguage}",
    "tracingTag": "${rtb}",
    "pageNumber": 1,
    "enableCookie": "On",
    "safeSearch": "Moderate",
    "testMode": "${(this.env === 'dev' || this.env === 'test') ? 'On' : 'Off'}",
    "personalization": "On",
    "disableTextAdExtensions": [],
    "disableProductAdExtensions": [],
    "adsRenderedCallback": function (containerId, adsLoaded, param, callbackOptions) {
      const logger = window.amgAds.bingJS.adPlacements[containerId].logger;
      logger.debug("BingJs adsLoaded", adsLoaded);
      logger.debug('callbackOptions', callbackOptions);
      const parentCallback = window.amgAds.adsLoadedCallback || function() {};
      if(adsLoaded) {
        // Ad-InView Event
        window.amgAds.bingJS.adPlacements[containerId]
        const bingPlacementsIds = Object.keys(window.amgAds.bingJS.adPlacements);
        const isFirstBlock = bingPlacementsIds.length && bingPlacementsIds[0] === containerId;
        const bingElement = document.getElementById(containerId);
        const IntersectionObserver = window.IntersectionObserver;
        const bingJsInViewObserver = new IntersectionObserver(function (entries) {
          if (entries[0].intersectionRatio > 0) {
            const gaPayload = logger.getInViewPayload(isFirstBlock);
            logger.logEvent(gaPayload);
            bingJsInViewObserver.unobserve(bingElement);
          }
        });
        bingJsInViewObserver.observe(bingElement);

        if(isFirstBlock) {
          const termPositions = callbackOptions ? callbackOptions.termPositions : '';
          const dabuRes = ${JSON.stringify(dabuRes)};
          const count = 0
          const block = window.amgAds.bingJsOptions.blocks.find( block => { return block.placementId === containerId } );
          const numLinks = termPositions ? Object.keys(termPositions).length : 0;
          const adResultsDisplayedTop = numLinks <= block.count ? numLinks : block.count;
          const adResultsDisplayedBottom = numLinks > block.count ? numLinks - block.count : undefined;
          const loggerPayload = {
            eventType: 'ContentRendered',
            numLinks: numLinks,
            termPositions: JSON.stringify(termPositions),
            adResultsDisplayedTop,
            adResultsDisplayedBottom
            };
          Object.assign(loggerPayload, dabuRes);
          
          const payload = logger.getContentRenderedPayload('bingjs', loggerPayload);
          logger.logEvent(payload);
        }
          
      } else {
        parentCallback(new Error('Ad not loaded.'), containerId);
      }
    },
    "containers": ${JSON.stringify(containers)}
  };
  
  searchAds(adsParameter);`;
  this.doc.head.appendChild(searchScript);
  this.doc.head.appendChild(clarityScript);
  searchScript.addEventListener('load', () => {
    this.doc.body.appendChild(initAdJS);
    this.logger.debug('Mounting initAdJS script to dom nodes', this.dataset.dabuPlacementId);
  });
}

async function getBingJSAds() {
  // we only use one placement for bing ads
  // so we can destructure the first item in the array here.
  try {
    const {
      o,
    } = this.pageParams;
    const dabuUrl = new URL(`${this.dabuUrl}/api/v2/ta/bingJS`);
    const { bingJsOptions = { slug: '', sksAsQuery: false } } = this.win.amgAds || {};

    dabuUrl.searchParams.set('o', o);
    dabuUrl.searchParams.set('sksAsQuery', bingJsOptions.sksAsQuery);
    dabuUrl.searchParams.set('surl', this.sourceUrl);
    const dabuRes = await this.callDabu(dabuUrl.toString());
    this.logger.debug('Bing js making a call to Dabu', dabuRes);
    // Disabling mountTelemateryScript implementation until the mapping is ready
    this.firePageViewPixel();
    this.mountBingJsScript(dabuRes);
  } catch (err) {
    // do nothing for bing search ads
    this.logger.error('error calling dabu', err);
  }
}

export { getBingJSAds, mountBingJsScript, createContainer };
